import { QueryKey as OriginQueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';

import { QUERY_KEY } from '@query/keys';
import { ApiRepository } from '@repositories/api';

import type {
  ChannelCpConsumptionAmountResponseError,
  ChannelCpConsumptionAmountResponseOK,
  GetChannelCpConsumptionAmountRequestPayload
} from '@repositories/api/dashboard.types';
import type { AxiosResponse } from 'axios';

type Props<Data extends AxiosResponse, ErrorResponse, QueryKey extends OriginQueryKey> = {
  queryParams: GetChannelCpConsumptionAmountRequestPayload['queryParams'];
  options?: Omit<
    UseQueryOptions<Data, ErrorResponse, Data['data']['data'], QueryKey>,
    'queryKey' | 'queryFn' | 'initialData'
  >;
};

function useGetChannelDailyCpConsumptionAmountQuery<
  Data extends ChannelCpConsumptionAmountResponseOK,
  ErrorResponse extends ChannelCpConsumptionAmountResponseError
>({
  queryParams,
  options
}: Props<
  Data,
  ErrorResponse,
  ReturnType<typeof QUERY_KEY.DASHBOARD.GET_CHANNEL_DAILY_CP_CONSUMPTION_AMOUNT>
>) {
  return useQuery({
    queryKey: QUERY_KEY.DASHBOARD.GET_CHANNEL_DAILY_CP_CONSUMPTION_AMOUNT({ queryParams }),
    queryFn: () => {
      return ApiRepository.dashboard.getChannelDailyCpConsumptionAmount({ queryParams });
    },
    select: (data) => data.data.data,
    ...options
  });
}

export { useGetChannelDailyCpConsumptionAmountQuery };
